import { ButtonLoader, Input, SelectInput } from 'components/__new/common/form'
import SignupFormHeader from './SignupFormHeader'
import AccountExistsButton from './AccountExistsButton'
import { ReactComponent as IconLeft } from "assets/images/icons/project-icons/arrow-left.svg";
import { ReactComponent as IconInfo } from "assets/images/icons/project-icons/question-icon.svg";
import { Country, State } from 'country-state-city';
import { useEffect, useState } from 'react'
import ReactTooltip from 'react-tooltip'


const GetStartedBusinessDetails = ({form, updateForm, formErrors, submitForm, setForm, decrementStep, loading}) => {
    
    const allCountries = Country.getAllCountries();
    const [states, setStates] = useState([]);
    // eslint-disable-next-line
    const [stateIsInput, setStateIsInput] = useState(false);
    
    const submitDisabled = (!form?.businessName?.length || formErrors?.businessName?.includes("Invalid") || formErrors?.businessName?.length)
                            || !form?.country?.length
                            || !form?.state?.length
                            || formErrors?.customRole?.includes("Invalid");
    
    const updateCountry = (e) => {
        const selected = allCountries?.find((item) => item.name === e.target.value);
        setForm({...form, country: selected?.name});
        
        const allStates = State.getStatesOfCountry(selected?.isoCode);
        setStates(allStates)
    }
    
    useEffect(() => {
        if(form.country?.length) {
            const selected = allCountries?.find((item) => item.name === form?.country);
            const allStates = State.getStatesOfCountry(selected?.isoCode);
            setStates(allStates)
        }
        // eslint-disable-next-line
    }, [form])
    
    useEffect(() => {
        if(form?.country?.length > 0 && states?.length === 0) {
            setStateIsInput(true);
        } else if(form?.country?.length > 0 && states?.length > 0) {
            setStateIsInput(false);
        }
        // eslint-disable-next-line
    }, [form?.country, states])
    
    return (
        <div>
            
            <SignupFormHeader 
                stepCount="2"
                headerText="Business Information"
                completionPercentage={100}
            />
            
            <button onClick={decrementStep} className='flex items-center mt-5 text-[#0D0C2B]'>
                <span className="mr-1 text-sm"><IconLeft className='text-xs' width={15} /></span>
                Back
            </button>
            
            <form onSubmit={submitForm}>
                <div className="mt-7 w-full max-w-md mx-auto md:mx-0 lg:w-96">
                    
                    <div className="w-full relative">
                        <Input
                            type="text" 
                            label="Business Name"
                            value={form.businessName} 
                            placeholder="Enter Business Name" 
                            tagText={formErrors?.businessName}
                            tagTextIsRed
                            onChange={(e) => updateForm(e, "businessName")}
                        />
                        
                        <div data-tip data-for="business-name-info" className='pr-2 cursor-pointer absolute right-1 top-8'><IconInfo /></div>
                    </div>
                    
                    <ReactTooltip type='light' backgroundColor='#fff' place='right' id="business-name-info" className="tooptip-size">
                        A Business name is the name that<br /> 
                        your business operates under. <br /> 
                        It should match the name on your <br />
                        CAC business registration document
                    </ReactTooltip>
                        
                    <div className="flex items-center justify-between w-full">
                        <div className="w-[48%]">
                            <SelectInput label="Country" value={form.country} onChange={(e) => updateCountry(e)}>
                                <option value="" disabled>Select Country</option>
                                {allCountries?.map((country) => (
                                    <option key={country?.isoCode} value={country?.name}>{country?.name}</option>
                                ))}
                            </SelectInput>
                        </div>
                        
                        <div className="w-[48%]">
                            <SelectInput disabled={!form?.country} label="State" value={form.state} onChange={(e) => setForm({...form, state: e.target.value})} >
                                <option value="" disabled>{form?.state?.length ? form?.state : !form?.country ? "Select a country" : "Select State"}</option>
                                {states?.map((state) => (
                                    <option key={state.name} value={state.name}>{state.name}</option>
                                ))}
                            </SelectInput>
                        </div>
                    </div>
                    

                    <ButtonLoader loading={loading} disabled={submitDisabled} type="submit" className="btn btn-lg btn-block btn-ep-primary mt-5 disabled:!bg-[#E2E8F0] disabled:cursor-not-allowed transition-colors duration-300">
                        Continue
                    </ButtonLoader>

                    <AccountExistsButton />
                </div>
            </form>
        </div>
    )
}

export default GetStartedBusinessDetails